/* ==========================================================================
   ASJ CUSTOM - Mobile-only "Back" control on product pages.
   Injects a small back button just above the product image so a shopper can
   return to the collection/page they came from. It is a real <a> (defaults to
   /collections/all with no JS); JS upgrades the click to history.back() when
   the previous page was on this store. Rendered only inside the product media
   wrapper, and CSS hides it above 749px, so desktop is untouched. Additive and
   isolated: deleting this file (and its line in asj-head.liquid) removes it.
   ========================================================================== */
(function () {
  'use strict';

  var FALLBACK = '/collections/all';

  function build() {
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap || wrap.querySelector('.asj-backbar')) return;

    var bar = document.createElement('div');
    bar.className = 'asj-backbar';

    var a = document.createElement('a');
    a.className = 'asj-backbar__btn';
    a.href = FALLBACK;
    a.setAttribute('aria-label', 'Go back to the previous page');
    a.innerHTML =
      '<svg class="asj-backbar__icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M12.5 4l-6 6 6 6" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span class="asj-backbar__label">Back</span>';

    a.addEventListener('click', function (e) {
      var sameSite =
        document.referrer &&
        (function () {
          try { return new URL(document.referrer).host === window.location.host; }
          catch (err) { return false; }
        })();
      if (window.history.length > 1 && sameSite) {
        e.preventDefault();
        window.history.back();
      }
      /* else: let the anchor navigate to FALLBACK naturally */
    });

    bar.appendChild(a);
    wrap.insertBefore(bar, wrap.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
